export default "__VITE_ASSET__CwCJnJhs__"